const Awesomplete = require('awesomplete');

/**
 * @param {Element} dropdown - js element for the dropdown wrapper
 * @description initialize adyen banks dropdown suggestion via Awesomplete tool
 */
function adyenSuggestionDropdown(dropdown) {
    let $cache = {};
    let awesomecompleteBankInput;
    let bankItemsData = {};
    let availableBanks = '';
    const BTN_ICON_CLEAR_CLASS = 'adyen-bank__btn--clear';
    const ITEM_CHOOSE_CLASS = 'adyen-bank__choose';
    const OPTIONS_NOT_EXIST_CLASS = 'adyen-bank__no-options--show';
    const DROPDOWN_SCROLLABLE_CLASS = 'adyen-bank__scroll';
    const MAX_BANK_ITEM_COUNT = 50;
    const MAX_BANK_ITEM_VISIBLE = 5;

    /**
     * @function
     * @description find and store all necessary DOM selectors
     */
    function initializeCache() {
        const wrapper = $(dropdown);
        $cache = {
            suggestionDropdown: wrapper,
            inputBtn: wrapper.find('.adyen-bank__btn'),
            inputVisible: wrapper.find('.adyen-bank__input'),
            inputHidden: wrapper.find('.adyen-bank__input-hidden'),
            noOptions: wrapper.find('.adyen-bank__no-options'),
            banksListWrapper: wrapper.find('.js_banks-list')[0],
            banksList: wrapper.find('.js_banks-list li')
        };
    }

    /**
     * @function
     * @description initialize all necessary functions which are responsible for DOM elements creation
     */
    function initializeDOM() {
        awesomecompleteBankInput = new Awesomplete($cache.inputVisible[0], {
            item: creatingItem,
            maxItems: MAX_BANK_ITEM_COUNT,
            list: $cache.banksListWrapper
        });

        /**
         * @function
         * @description creating item for Awesomplete dropdown
         * @param {Object} suggestion - suggestion data
         * @returns {Object} - dropdown item
         */
        function creatingItem(suggestion) {
            return Awesomplete.$.create('li', {
                innerHTML: getTemplate(suggestion),
                'aria-selected': 'false',
                class: 'ui-menu-item adyen-bank__item'
            });
        }

        getBankItemsData();

        /**
         * @function
         * @description creating HTML template for ech Awesomplete item
         * @param {Object} suggestion - suggestion data
         * @returns {string} - HTML template via string literal
         */
        function getTemplate(suggestion) {
            const itemTemplate = `
                <object class="adyen-bank__item-icon" data="${
                    bankItemsData[suggestion.label].img
                }" type="image/svg+xml"></object>
                ${suggestion.label}
                <i class="icon icon-arrow_right adyen-bank__btn-icon--arrow"></i>`;
            return itemTemplate;
        }
    }

    /**
     * @function
     * @description initialize all DOM events
     */
    function initializeEvents() {
        Awesomplete.$($cache.inputVisible).on('click', function () {
            if (awesomecompleteBankInput.ul.childNodes.length === 0) {
                awesomecompleteBankInput.minChars = 0;
                awesomecompleteBankInput.evaluate();
                toggleDropdownListScrollClass();
            } else if (awesomecompleteBankInput.ul.hasAttribute('hidden')) {
                toggleDropdownListScrollClass();
                awesomecompleteBankInput.open();
            } else {
                awesomecompleteBankInput.close();
            }
        });

        window.addEventListener(
            'awesomplete-selectcomplete',
            function () {
                $cache.inputBtn.addClass(BTN_ICON_CLEAR_CLASS);
                const selectedItem = $cache.inputVisible.val().trim();
                const selectedItemImageSrc = bankItemsData[selectedItem].img;
                const selectedItemValue = bankItemsData[selectedItem].value;

                $cache.inputVisible
                    .css('background-image', `url(${selectedItemImageSrc})`)
                    .addClass(ITEM_CHOOSE_CLASS)
                    .trigger('input');
                $cache.inputHidden.val(selectedItemValue);
            },
            false
        );

        $cache.inputBtn.on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass(BTN_ICON_CLEAR_CLASS)) {
                $(this).removeClass(BTN_ICON_CLEAR_CLASS);
                clearInput();
                awesomecompleteBankInput.evaluate();
            }

            $cache.inputVisible.trigger('click');
        });

        $cache.inputVisible.on('blur', function () {
            if (!bankItemsData[this.value]) {
                $cache.inputBtn.removeClass(BTN_ICON_CLEAR_CLASS);
                $cache.noOptions.removeClass(OPTIONS_NOT_EXIST_CLASS);
                clearInput();
                awesomecompleteBankInput.evaluate();
                awesomecompleteBankInput.close();
            }
        });

        $cache.inputVisible.on('keyup', function () {
            const searchPhrase = $(this)[0].value.replace(/\s\s+/g, ' ').trim().toLowerCase();
            const isSearchPhraseExist = availableBanks.includes(searchPhrase);

            toggleDropdownListScrollClass();

            if (!isSearchPhraseExist) {
                $cache.noOptions.addClass(OPTIONS_NOT_EXIST_CLASS);
            } else {
                $cache.noOptions.removeClass(OPTIONS_NOT_EXIST_CLASS);
                $cache.inputVisible.css('background-image', '').removeClass(ITEM_CHOOSE_CLASS);
            }
        });

        $cache.inputVisible.on('input', function () {
            if ($(this).val()) {
                $cache.suggestionDropdown.removeClass('validation-error');
                $('.error-msg-inner').hide();
            }
        });
    }

    /**
     * @function
     * @description getting all banks data
     */
    function getBankItemsData() {
        const itemsObj = {};
        itemsObj.bankNames = [];

        $cache.banksList.each(function (index, elem) {
            itemsObj[$(elem).text().trim()] = {
                img: $(elem).attr('data-image'),
                value: $(elem).attr('data-value')
            };

            itemsObj.bankNames.push(elem.textContent.trim());
        });

        bankItemsData = itemsObj;
        availableBanks = itemsObj.bankNames.join(' ').toLowerCase();
    }

    /**
     * @function
     * @description clear input value and removing styles
     */
    function clearInput() {
        $cache.inputHidden.val('');
        $(awesomecompleteBankInput.input).val('');
        $cache.inputVisible.css('background-image', '').removeClass(ITEM_CHOOSE_CLASS);
    }

    /**
     * @function
     * @description set specific class if dropdown list scrollable
     */
    function toggleDropdownListScrollClass() {
        setTimeout(function () {
            const dropdownList = $cache.inputVisible.next('ul[role=listbox]');
            const dropdownListItem = dropdownList.find('li');
            const dropdownListHeight = dropdownList.outerHeight();
            const dropdownListItemHeight = dropdownListItem.outerHeight();
            const dropdownListMaxHeight = MAX_BANK_ITEM_VISIBLE * dropdownListItemHeight;

            dropdownList.css('max-height', dropdownListMaxHeight);

            if (dropdownListHeight >= dropdownListMaxHeight) {
                $cache.suggestionDropdown.addClass(DROPDOWN_SCROLLABLE_CLASS);
            } else {
                $cache.suggestionDropdown.removeClass(DROPDOWN_SCROLLABLE_CLASS);
            }
        });
    }

    initializeCache();
    initializeDOM();
    initializeEvents();
}

/**
 * @function
 * @description export main function
 */
exports.init = () => {
    $('.js_suggestion-dropdown').each((_, dropdown) => {
        adyenSuggestionDropdown(dropdown);
    });
};
